<template>
	<div class="tab">
		<ul>
			<li
				class="tab-item"
				:class="{ active: item.value === current }"
				:key="item.value"
				v-for="(item, index) in tabData"
				@click="handleClick(item.value)"
			>
				{{ item.label }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'tab',
	props: {
		tabData: {
			type: Array,
			default: () => [
				{ label: '全部', value: 1 },
				{ label: '未兑奖', value: 2 },
				{ label: '已兑奖', value: 3 },
			],
		},
	},
	data: () => ({
        current: 1,
        width: null,
        offset: 0,
	}),
	methods: {
		handleClick(value) {
			this.current = value
			this.$emit('tab-click', value)
			if(!this.$parent.handleClickTab){
				this.$parent.page=1
				this.$parent.pageSize=15
				this.$parent.search_name = ''
				this.$parent.type=value
				this.$parent.listData = [];
				this.$parent.getList()
			}
		},
	},
}
</script>

<style lang="less" scoped>
.tab {
	position: relative;
	ul {
		display: flex;
	}
	&-item {
		flex: 1 0 auto;
		text-align: center;
		font-size: 14px;
		color: #666666;
		height: 40px;
		line-height: 40px;
		transition: all 0.3s ease;
	}
	&-item.active {
		border-bottom: 2px solid #3C43EC;
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.border {
		position: absolute;
		left: 0;
		bottom: 0;
		// width: 100%;
		height: 2px;
		background: rgba(60, 67, 236, 1);
	}
}
</style>
